import { css } from '@linaria/core';
const iconSize = '48px';
export const IconWrapper = {
    base: css `
		display: flex;
		align-items: center;
		justify-content: center;

		border-radius: 50%;

		background-color: rgb(var(--pager-background-alpha));

		transition: all 150ms var(--global-ease-in-out);

		svg {
			transform: scale3d(1, 1, 1);

			box-sizing: border-box;
			width: ${iconSize};
			height: ${iconSize};
			padding-right: 3px;

			path {
				fill: rgb(var(--pager-icon-alpha));
			}
		}
	`,
};
export const Root = {
    base: css `
		&&& {
			cursor: pointer;

			top: 0;

			overflow: hidden;
			display: flex;
			flex-direction: column;
			justify-content: center;

			width: calc(${iconSize} + var(--pager-spacing-padding-base));
			height: 100%;
			margin: 0;

			opacity: 0;
			background-image: none;
			outline: none;

			transition: opacity 200ms var(--global-ease-in-out);

			-webkit-tap-highlight-color: transparent;

			&:after {
				content: '';

				position: absolute;
				z-index: -1;
				top: 50%;

				display: inline-block;

				width: 200px;
				height: 200px;
				margin-top: -100px;
				border-radius: 100%;
			}

			&.swiper-button-disabled {
				pointer-events: none;
				.${IconWrapper.base} {
					opacity: 0;
				}
			}

			@media (pointer: coarse) {
				display: none;
				opacity: 0;
			}

			@media (any-hover: hover), (any-pointer: fine) {
				&:hover {
					.${IconWrapper.base} {
						background-color: rgb(var(--pager-hover-alpha));
					}

					svg path {
						fill: rgb(var(--pager-icon-hover-alpha));
					}
				}
			}
		}
	`,
    isVisible: css `
		&&& {
			opacity: 1;

			@media (pointer: coarse) {
				display: flex;
				opacity: 1;
			}
		}
	`,
    direction: {
        right: css `
			&&& {
				right: 0;
				.${IconWrapper.base} {
					align-self: flex-end;
					margin-right: var(--pager-spacing-padding-base);

					svg {
						transform: scale3d(1, 1, 1) rotate(180deg);
					}
				}
			}
		`,
        left: css `
			&&& {
				left: 0;
				.${IconWrapper.base} {
					align-self: flex-start;
					margin-left: var(--pager-spacing-padding-base);
				}
			}
		`,
    },
};
